import { type PropsWithChildren } from 'react';

import { getShownIndicators } from '../../core/components/annotations/components/indicators/utils/get-shown-indicators.js';
import { HistogramAnnotationsDataContext } from '../contexts/HistogramAnnotationsData.context.js';
import { useAnnotationsState } from '../hooks/store/selectors.js';
import { useHistogramAnnotationsConfig } from '../hooks/useHistogramAnnotationsConfig.js';

export const HistogramAnnotationsDataProvider = ({
  children,
}: PropsWithChildren) => {
  const selection = useAnnotationsState();
  const { tracks } = useHistogramAnnotationsConfig();

  const shownIndicators = getShownIndicators(tracks, selection);

  return (
    <HistogramAnnotationsDataContext.Provider
      value={{ indicators: shownIndicators }}
    >
      {children}
    </HistogramAnnotationsDataContext.Provider>
  );
};

HistogramAnnotationsDataProvider['displayName'] =
  'HistogramAnnotationsDataProvider';
